import React from 'react';
import {
  GridColumn,
  LargeHeader,
  Layout,
  LayoutItem,
  Tooltip,
} from '@axiom/ui';

export type OpportunitySubmissionCandidateRateCurrencyConversionProps = {
  clientCurrencyLabel: React.ReactNode;
  convertedComp: string;
  tooltipContent: React.ReactNode;
};

export const OpportunitySubmissionCandidateRateCurrencyConversion = ({
  clientCurrencyLabel,
  convertedComp,
  tooltipContent,
}: OpportunitySubmissionCandidateRateCurrencyConversionProps) => (
  <>
    <GridColumn
      width={1}
      verticalAlign="middle"
      name="currency-conversion-equals-copy"
    >
      <LargeHeader>=</LargeHeader>
    </GridColumn>
    <GridColumn width={5} verticalAlign="top" name="currency-conversion">
      <Layout direction="vertical">
        <LayoutItem topGutter="4px">
          <Layout>
            <LayoutItem name="converted-to-currency-label">
              Converted to {clientCurrencyLabel}
            </LayoutItem>
            <LayoutItem position="right" fluid>
              <Tooltip name="converted-to-currency-tooltip">
                {tooltipContent}
              </Tooltip>
            </LayoutItem>
          </Layout>
        </LayoutItem>
        <LayoutItem name="converted-comp" topGutter="4px">
          {convertedComp}
        </LayoutItem>
      </Layout>
    </GridColumn>
  </>
);
